{
  "title": "Client Master",
  "subtitle": "3PL clients whose goods this warehouse stores — the owner-of-inventory dimension used across Material Requests, GRN, Dispatch, and Production once Third-Party Logistics is enabled.",
  "addClient": "Add Client",
  "search": "Search clients...",
  "edit": "Edit",
  "delete": "Delete",
  "table": {
    "code": "Code",
    "name": "Client Name",
    "gstin": "GSTIN",
    "contactPerson": "Contact Person",
    "phone": "Phone",
    "status": "Status"
  },
  "tabs": {
    "general": "General",
    "billing3pl": "Billing & 3PL"
  },
  "form": {
    "code": "Client Code",
    "name": "Client Name",
    "gstin": "GSTIN",
    "address": "Address",
    "contactPerson": "Contact Person",
    "phone": "Phone",
    "email": "Email",
    "status": "Status",
    "state": "State (for GST)",
    "stateNone": "— Not set —",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "billingContactName": "Billing Contact Name",
    "billingContactEmail": "Billing Contact Email",
    "billingContactPhone": "Billing Contact Phone",
    "creditTermDays": "Credit Term (Days)",
    "creditTermDaysHelper": "Payment terms, e.g. 30 for Net 30. Informational only.",
    "primaryBranch": "Primary Servicing Branch",
    "primaryBranchNone": "— Not set —",
    "primaryBranchHelper": "The branch/warehouse that primarily services this client.",
    "specialHandlingInstructions": "Special Handling Instructions",
    "mappedCustomers": "Mapped Customers",
    "mappedCustomersHelper": "Which Customers this Client's goods are dispatched to — narrows the Customer picker on Material Master and the Client picker on Dispatch to only these.",
    "validation": {
      "codeRequired": "Client code is required.",
      "nameRequired": "Client name is required."
    }
  },
  "discardChanges": "Discard Changes",
  "saveClient": "Save Client",
  "deleteClient": {
    "message": "This client will be permanently removed."
  }
}
